module.exports = __webpack_public_path__ + "static/media/member_prog_logo.ac04b038.svg";